module.exports = __webpack_public_path__ + "assets/img/1606_02.jpg?0719e393d23462af87d8053338f8cd90";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1606_02.jpg
// module id = 1112
// module chunks = 0